import dataQuery from './dataQuery'

export default {
  data() {
    return {
      queryDto: {
        hth: '',
        djh: '',
        code: '',
        limit: 50,
        currentPage: 1
      },
      amountTotal: 0.00,
      total: 0,
      tableData: []
    }
  },

  created() {
    dataQuery.setThis(this)
    this.queryBillData()
  },
  methods: {
    /* 每页多少条 */
    handleSizeChange(size) {
      this.queryDto.limit = size
      this.queryBillData()
    },
    // 调制 第几页
    handleCurrentChange(currentpage) {
      this.queryDto.currentPage = currentpage
      this.queryBillData()
    },
    queryDtoChange() {
      this.queryDto.limit = 50
      this.queryDto.currentPage = 1
    },
    queryBillData() {
      const loading = this.$loading({
        lock: true,
        text: '查询中,请稍后...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      this.$post('/fesback/contractcostdetails/detailslist.z', this.queryDto).then(res => {
        if (res.data) {
          this.tableData = res.data.data
          this.total = res.data.total
          this.amountTotal = res.data.amountTotal
        }
        loading.close()
      }).catch(res => {
        this.$message.error(res)
        loading.close()
      })
    }

  }
}
